import React from 'react';
import { connect } from 'react-redux';

import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';

import * as selectors from '../selectors';

import ProblemVariants from './../__variants/problem-view__variants';
import ProblemVariantsHeader from './../__variants/problem-view__variants-header';
import SidePanel, { SidePanelProps } from './problem-view__side-panel';

interface StoreProps {
    hasVariants: boolean;
}

type Props = StoreProps & SidePanelProps;

export const VariantsSidePanel = ({ hasVariants, ...sidePanelProps }: Props) => {
    if (!hasVariants) {
        return null;
    }

    return (
        <SidePanel header={<ProblemVariantsHeader />} {...sidePanelProps}>
            <ProblemVariants />
        </SidePanel>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    const stackId = lessonViewSelectors.getProblemStackId(storeState);
    const hasVariants = selectors.getHasVariants(storeState, { stackId });

    return { hasVariants };
};

export default connect(mapStateToProps)(VariantsSidePanel);
